import { useParams } from "react-router-dom";
import { FEATURE_PAGES_BY_SLUG } from "@/lib/featurePages";
import { FeaturePageLayout } from "@/components/marketing/FeaturePageLayout";
import NotFound from "@/pages/NotFound";

/**
 * Single route component that resolves `/features/:slug/` against the
 * FeaturePage registry. Unknown slugs fall through to the 404 page so SEO
 * sees a proper "not found" surface.
 */
const FeaturePage = () => {
  const { slug } = useParams<{ slug: string }>();
  const page = slug ? FEATURE_PAGES_BY_SLUG[slug] : null;
  if (!page) return <NotFound />;
  return <FeaturePageLayout page={page} />;
};

export default FeaturePage;
